import { auth } from "./firebase";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

async function getHeaders() {
  const user = auth.currentUser;
  if (!user) return { "Content-Type": "application/json" };
  const token = await user.getIdToken();
  return {
    "Content-Type":  "application/json",
    "Authorization": `Bearer ${token}`,
  };
}

async function apiFetch(path) {
  const headers = await getHeaders();
  const res = await fetch(`${API_URL}${path}`, { headers });
  if (!res.ok) throw new Error(`API error: ${res.status}`);
  return res.json();
}

export const api = {
  stats:        () => apiFetch("/api/stats"),
  trades:       (n = 100) => apiFetch(`/api/trades?limite=${n}`),
  versoes:      () => apiFetch("/api/versoes"),
  status:       () => apiFetch("/api/status"),
  conhecimento: () => apiFetch("/api/conhecimento"),
  regras:       () => apiFetch("/api/regras"),
};
